import React from 'react';
import { Ticket } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/Card';
import { formatMoney } from '../../utils/formatMoney';
import { SOI_DAO_STATUS_LABELS } from '../../utils/soiDaoUtils';

export function SoiDaoPlayRow({ play, roomName }) {
  const payout = Number(play.payout) || 0;
  const isWin = payout > 0;
  let statusText = 'รอผล';
  let statusClass = 'bg-amber-50 text-amber-700';
  let rowClass = 'border-gray-100 bg-gray-50';

  if (play.status === 'settled' && isWin) {
    statusText = 'ถูกรางวัล';
    statusClass = 'bg-green-100 text-green-800';
    rowClass = 'border-green-300 bg-green-50';
  } else if (play.status === 'settled') {
    statusText = 'ไม่ถูก';
    statusClass = 'bg-gray-100 text-gray-600';
  }

  const stars = play.stars || [];

  return (
    <li
      className={`rounded-xl border-2 px-4 py-3 text-sm ${rowClass}`}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="font-semibold text-brand-red">
            {roomName || play.roomId} · รอบ #{play.roundNumber}
          </p>
          <p className="mt-0.5 break-all font-mono text-xs text-gray-600">
            {stars.map((star) => star.position).join(', ') || '-'}
          </p>
          <p className="mt-0.5 text-xs text-gray-400">
            {play.createdAt
              ? new Date(play.createdAt).toLocaleString('th-TH')
              : '-'}
            {' · '}
            {formatMoney(play.amount)} · {stars.length} ดาว
          </p>
        </div>
        <div className="shrink-0 text-right">
          <span
            className={`inline-block rounded-full px-2.5 py-1 text-xs font-semibold ${statusClass}`}
          >
            {statusText}
          </span>
          {isWin ? (
            <p className="mt-1 text-sm font-bold text-green-700">
              ได้รางวัล {formatMoney(payout)}
            </p>
          ) : null}
        </div>
      </div>
      {stars.some((star) => star.result) ? (
        <ul className="mt-2 flex flex-wrap gap-1.5">
          {stars.map((star) => {
            const status =
              SOI_DAO_STATUS_LABELS[star.status] || SOI_DAO_STATUS_LABELS.pending;
            return (
              <li
                key={`${play.id}-${star.position}`}
                className={`rounded-md px-2 py-1 text-[11px] ${status.className}`}
              >
                <span className="font-mono font-bold">{star.position}</span>
                {star.result ? (
                  <span className="ml-1 font-mono">→ {star.result}</span>
                ) : null}
                {Number(star.payout) > 0
                  ? ` · ${formatMoney(star.payout)}`
                  : ''}
              </li>
            );
          })}
        </ul>
      ) : null}
    </li>
  );
}

export function SoiDaoPlaysPanel({ plays = [], title = 'การเล่นของฉัน' }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-base">
          <Ticket className="h-5 w-5 text-brand-red" />
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent>
        {plays.length === 0 ? (
          <p className="text-sm text-gray-500">ยังไม่มีประวัติการเล่น</p>
        ) : (
          <ul className="max-h-72 space-y-2 overflow-y-auto">
            {plays.map((play) => (
              <SoiDaoPlayRow key={play.id} play={play} />
            ))}
          </ul>
        )}
      </CardContent>
    </Card>
  );
}
